var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#14144B;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.61,201.04H103.39c-22.74,0-41.17-18.43-41.17-41.17s18.43-41.17,41.17-41.17h513.23c22.74,0,41.17,18.43,41.17,41.17s-18.43,41.17-41.17,41.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.61,401.17H103.39c-22.74,0-41.17-18.43-41.17-41.17s18.43-41.17,41.17-41.17h513.23c22.74,0,41.17,18.43,41.17,41.17s-18.43,41.17-41.17,41.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.61,601.3H103.39c-22.74,0-41.17-18.43-41.17-41.17s18.43-41.17,41.17-41.17h513.23c22.74,0,41.17,18.43,41.17,41.17s-18.43,41.17-41.17,41.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.1d1361620ed5b3722f7172c2a836583f.svg";
export { ForwardRef as ReactComponent };